export enum BrandSplitType {
  AVAILABILITY = 'AVAILABILITY',
  DELIVERY_WINDOW = 'DELIVERY_WINDOW',
  CLASSIFICATION_TYPE = 'CLASSIFICATION_TYPE',
}

export interface BrandSplitSettingsDTO {
  type: BrandSplitType;
  label: string;
  customId?: string;
}

export interface BrandSplitSettings extends BrandSplitSettingsDTO {
  key: string; // usado para manusear o tipo de split no front
}
